import { useState } from "react";

import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import Tab from "ds/components/Tab";
import TabPanel from "ds/components/TabPanel";

import { SCAN_DETAILS_DRAWER_TABS } from "./constants";
import ScanDetailsDrawerTabContent from "./TabContent";
import { ScanDetailsDrawerItem, ScanDetailsDrawerTab } from "./types";

type ScanDetailsDrawerProps = {
  scan: ScanDetailsDrawerItem;
};

const ScanDetailsDrawer = createDrawer(({ scan }: ScanDetailsDrawerProps) => {
  const [currentTab, setCurrentTab] = useState(ScanDetailsDrawerTab.ScanDetails);
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(scan.description);

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Scan details" />
        <DrawerCloseIcon />
      </DrawerHeader>

      <DrawerBody>
        <Box gap="medium" margin="0 0 large" role="tablist">
          {SCAN_DETAILS_DRAWER_TABS.map(({ id, label }) => (
            <Tab
              key={id}
              onClick={setCurrentTab}
              isActive={currentTab === id}
              id={id}
              label={label}
            />
          ))}
        </Box>

        {SCAN_DETAILS_DRAWER_TABS.map(({ id }) => (
          <TabPanel key={id} isActive={currentTab === id} id={id}>
            <ScanDetailsDrawerTabContent
              scan={scan}
              tab={id}
              onOpenFullDescription={onOpenFullDescription}
            />
          </TabPanel>
        ))}
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showScanDetailsDrawer = createDrawerTrigger(ScanDetailsDrawer);
